import {useUpdateWithPDF} from 'components/hooks/useUpdate';
import {content} from 'constants/url';
import {EditingOptions} from '../../../components/grid-dx/types';

function useUpdateContent() {
  const updateContent = useUpdateWithPDF(content);
  return (editingOptions: EditingOptions) => updateContent(editingOptions);
}

export default useUpdateContent;
